import { useEffect, useState } from 'react'
import MyDiv from './salaryHistory.style'
import { Box, Button, Grid, GridItem, Popover, PopoverBody, Text, PopoverContent, PopoverTrigger, useDisclosure, Flex } from '@chakra-ui/react';
import SalaryHistoryCard from './Components/SalaryHistoryCard';
import { CalendarIcon } from '@chakra-ui/icons';
import Calendar from 'react-calendar';
import SalaryList from './Components/SalaryList';
import { useLocation } from 'react-router-dom';
import { CustomToast } from '../../components';
import { useFetch } from '../../hooks/useFetch';
import { IPayrollData } from '../Payroll/components/PayrollList/modal';
// const dummyData = [
//   { id: 1, month: 'January', grossSalary: 12342, netPay: 43534, deduction: 4545, bonus: 656, workingDays: 1, netPayableDays: 30, lop: 10, tds: 656, pf: 12342, status: 'Completed' },
//   { id: 2, month: 'February', grossSalary: 3454, netPay: 4354353, deduction: 454, bonus: 56565, workingDays: 22, netPayableDays: 20, lop: 2, tds: 565, pf: 12676342, status: 'Completed' },
//   { id: 3, month: 'March', grossSalary: 43554, netPay: 545, deduction: 4545, bonus: 3424, workingDays: 26, netPayableDays: 10, lop: 5, tds: 12342, pf: 5665, status: 'Completed' },
//   { id: 4, month: 'April', grossSalary: 5656, netPay: 454, deduction: 123454542, bonus: 56546, workingDays: 28, netPayableDays: 28, lop: 4, tds: 5656, pf: 56, status: 'Completed' },
//   { id: 5, month: 'May', grossSalary: 34234, netPay: 445545, deduction: 12334342, bonus: 909, workingDays: 15, netPayableDays: 24, lop: 6, tds: 65, pf: 12342, status: 'Completed' },
//   { id: 6, month: 'June', grossSalary: 5454, netPay: 124545342, deduction: 7878, bonus: 908, workingDays: 19, netPayableDays: 26, lop: 5, tds: 125656342, pf: 5656, status: 'Completed' },
//   { id: 7, month: 'October', grossSalary: 455, netPay: 45, deduction: 8778, bonus: 890, workingDays: 20, netPayableDays: 14, lop: 9, tds: 12342, pf: 12565342, status: 'Completed' }
// ];
const getStatusClass = (status: string) => {
  switch (status) { case 'Completed': return 'status_badge green'; case 'Pending': return 'status_badge orange'; case 'Rejected': return 'status_badge red'; case 'In-Progress': return 'status_badge blue'; case 'Sent for Approval': return 'status_badge orange'; case 'Approved by BranchHead': return 'status_badge purple'; default: return 'status_badge'; }
};

const sortOptions = ['Gross Salary (Low to High)',
  'Gross Salary (High to Low)',
  'Net Pay (Low to High)',
  'Net Pay (High to Low)',
  'Deductions (Low to High) ',
  'Deductions (High to Low)',
  'Bonus (Low to High) ',
  'Bonus (High to Low) ',
  'Working Days (Low to High) ',
  'Working Days (High to Low)',
  'LOP (Low to High) ',
  'LOP (High to Low)',
  'TDS (Low to High)',
  'TDS (High to Low)',
  'PF (Low to High)',
  'PF (High to Low)'];

export interface ITotals {
  totalGross: number, totalNetSalary: number, totalDeductions: number, totalOtherEarning: number, averageMonthlyNetSalary: number
}

const SalaryHistory = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [payrolls, setPayrolls] = useState<IPayrollData>({ data: [], totalCount: 0, loading: false });
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [selected, setSelected] = useState<string>(sortOptions[0]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { isOpen, onOpen, onClose } = useDisclosure();
  const formatMonthYear = (date: Date) =>
    date.toLocaleString('default', { year: 'numeric' });
  const [cards, setCards] = useState<{ label: string, value: string, color: string }[]>([]);
  const location = useLocation();
  const { employeeId } = location.state || {};

  async function loadPayrolls(_year: number) {
    const result = await fetchApi<any>(`Payroll/Employee/${employeeId}`, 'GET', null, `year=${_year}`);
    if (result) {
      if (result.data.length === 0) {
        addToast({ message: "No payrolls found.", status: "info" });
      }
      setSelectedRows([]);
      setPayrolls({ data: result.data, totalCount: result.totalRecords, loading: false });
    }
  }
  async function loadTotals(_year: number) {
    const result = await fetchApi<ITotals>(`Payroll/Employee/${employeeId}/YTD`, 'GET', null, `year=${_year}`);
    if (result) {
      setCards([
        { label: 'Total Gross Paid YTD', value: `₹ ${result.totalGross}`, color: '#E0F7F6' },
        { label: 'Total Net Paid YTD', value: `₹ ${result.totalNetSalary}`, color: '#E8F5E9' },
        { label: 'Total Deductions YTD', value: `₹ ${result.totalDeductions}`, color: '#FFEBEE' },
        { label: 'Total Bonus Paid YTD', value: `₹ ${result.totalOtherEarning}`, color: '#FFF3E0' },
        { label: 'Avg Monthly Net Pay', value: `₹ ${result.averageMonthlyNetSalary}`, color: '#EFEBE9' },
      ]);
    }
  }

  useEffect(() => {
    loadPayrolls(selectedDate.getFullYear());
    loadTotals(selectedDate.getFullYear());
  }, [selectedDate]);

  return (
    <MyDiv>
      <Grid className='grid_container' h="100vh" overflow="hidden" templateColumns="repeat(12, 1fr)">
        <GridItem colSpan={4} h="100vh" overflow="hidden">
          <Box position="sticky" top="0" h="100vh" overflowY="auto" className='tab-list-container'>
            <SalaryHistoryCard employeeId={employeeId} />
          </Box>
        </GridItem>
        <GridItem colSpan={8} h="100vh" overflowY="auto" className='tab-list-container' pr={4} pl={4}>
          <Box display="flex" justifyContent="flex-end" >
            <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
              <PopoverTrigger>
                <Button leftIcon={<CalendarIcon />} padding={3} variant="outline">
                  <Text className="font-poppins text_sm text_regular">
                    {formatMonthYear(selectedDate)}
                  </Text>
                </Button>
              </PopoverTrigger>
              <PopoverContent w="auto">
                <PopoverBody p={2} display="flex" justifyContent="center">
                  <Calendar value={selectedDate}
                    onChange={(value) => {
                      if (value instanceof Date) {
                        setSelectedDate(value);
                        onClose();
                      }
                    }}
                    view="year"
                    maxDetail="decade"
                    minDetail="decade"
                    maxDate={new Date()}
                  />
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Box>
          <Grid templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)', xl: 'repeat(5, 1fr)', }} gap={4} mt={4} >
            {cards.map((card, index) => (
              <Box key={index} bg={card.color} p={4} textAlign="left" borderRadius="md" height={'auto'} gap={4} className="font-poppins text_md text_medium">
                <Text className='font-poppins text_medium text_sm' mb={2}>{card.label}</Text>
                <Text className='font-poppins text_medium text_xl' >{card.value}</Text>
              </Box>
            ))}
          </Grid>
          <Grid className="grid_container" mb={8} mt={8}>
            <GridItem colSpan={12}>
              <SalaryList payrolls={payrolls} sortOptions={sortOptions} selectedRows={selectedRows} setSelectedRows={setSelectedRows} selected={selected} setSelected={setSelected} getStatusClass={getStatusClass} />
            </GridItem>
          </Grid>
        </GridItem>
      </Grid>
    </MyDiv>
  );
};

export default SalaryHistory;
